import _isUndefined from 'lodash/isUndefined';
import _omitBy from 'lodash/omitBy';

function omitUndefined(obj) {
  return _omitBy(obj, _isUndefined);
}

export { omitUndefined };
